import { Component, input } from '@angular/core';
import { AdminContractService, CollectionApi, ContractSite } from '@shared/services/admin-contract.service';
import { ContractCollectionComponent } from '../contract-collection.component';
import { AdminSiteSelectorComponent } from '@shared/components/admin-site-selector/admin-site-selector.component';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { TypedTemplateDirective } from '@shared/directives/typed-template.directive';
import { BadgeOrganizationComponent } from '@shared/components/badge-organization/badge-organization.component';
import { TablePagerComponent } from '@shared/components/table-pager/table-pager.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-contract-sites',
  inputs: ['contractNumber'],
  templateUrl: './contract-sites.component.html',
  styleUrls: ['./contract-sites.component.scss'],
  imports: [
    AdminSiteSelectorComponent,
    NgxDatatableModule,
    TypedTemplateDirective,
    BadgeOrganizationComponent,
    TablePagerComponent,
    TranslatePipe,
  ],
})
export class ContractSitesComponent extends ContractCollectionComponent<ContractSite, ContractSite> {
  public canBeEdited = input<boolean>(true);

  constructor(admin: AdminContractService) {
    super(admin);
  }

  override getCollectionApi(): CollectionApi<ContractSite> {
    return this.admin.sites(this.contractNumber);
  }

  protected getItemId(item: ContractSite) {
    return item.domainName;
  }
}
